import {useGetApi} from '@/uses/Api/useGetApi'
import {ref} from 'vue'
import {AgentPortalData} from '@/models/Portal/AgentPortalData'
import {EnvCodeEnum, useEnvStore} from '@/stores/useEnvStore'

export const useGetPartnerPortalData = () => {
  const {
    loading,
    get,
    status,
    response,
  } = useGetApi<AgentPortalData>()

  const {
    getEnvValue,
    isEditable,
  } = useEnvStore()

  const data = ref<AgentPortalData>()

  const load = async () => {
    const host = !isEditable(EnvCodeEnum.VUE_APP_API_URL)
      ? document.location.hostname
      : getEnvValue(EnvCodeEnum.VUE_TESTHOST)

    await get(
      `client/v1/sign-portals/${host}`,
    )

    if (status.value === 200 && response && response.value) {
      data.value = response.value
    }
  }

  return {
    loading,
    data,
    status,
    load,
  }
}
